module.exports = __webpack_public_path__ + "static/image-02-a@2x-d8dd3235c373e1fc85507568650ab3fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/zinc/image-02-a@2x.jpg
// module id = 436
// module chunks = 3627797113349 20562973939449 33019919093843